import React from 'react'
import './followandfeed.css'

const FollowAndFeed =()=>{
    return(
        <div className='feed-body'>
            <div className='feed'>
                <div className='trending'>
                    <h3>Trending</h3>
                    <p>Coming Soon...</p>
                </div><hr/>
                <div className='Topics'>
                    <h3>Topics</h3>
                    <p>Coming Soon...</p>
                </div><hr/>
                <div className ='about'>
                    <h3>About</h3>
                    <p>A place to get and give your onions on some intersting stuff, Get your weired questions to come up to get people's onions. </p>
                </div>
                <div>

                </div>
            </div>
            <small>© Copyright 2020, InmyOnion<br/> Developer Harish @zybnet</small>
        </div>  
    )
}

export default FollowAndFeed